import { cookiesGlobal } from "../App";
import { HttpUrls } from "../global/http_url";

const CreateProblem = async (projectID, pickedPD, data, domain) => {
    const token = cookiesGlobal.get('auth');
    try {
        let response = await fetch(`${HttpUrls.createProblem}/${projectID}`, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,
            },

            method: 'POST',
            body: JSON.stringify({
                'pricipal_defeciency': pickedPD,
                'problem_mapped_to': data,
                "domain": domain,
            })
        });
        const responseData = await response.json();
        if (response.status === 200) {
            return {
                statusCode: response.status,
                response: responseData['data'],
            }
        } else {
            return {
                statusCode: response.status,
                response: responseData['message'],
            }
        }

    } catch (e) {
        return {
            statusCode: 505,
            response: 'Intertnet Connection',
        }
    }
}
export { CreateProblem, }